import React, { useState, useEffect } from 'react';
import { authAPI } from '../../services/api';
import '../../styles/auth/FirstLoginSetup.css';

const FirstLoginSetup = ({ onComplete }) => {
    const [transactionPassword, setTransactionPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const generated = Math.floor(100000 + Math.random() * 900000).toString();
        setTransactionPassword(generated);
        setConfirmPassword(generated);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (transactionPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        
        if (transactionPassword.length !== 6 || !/^\d+$/.test(transactionPassword)) {
            setError('Password must be a 6-digit number');
            return;
        }
        
        setLoading(true);
        setError('');
        
        try {
            const response = await authAPI.setTransactionPassword({ transactionPassword });
            if (response.success) {
                onComplete();
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to set transaction password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="first-login-overlay">
            <div className="first-login-modal">
                <h2>Welcome! Set Your Transaction Password</h2>
                <p className="warning">
                    ⚠️ <strong>Important:</strong> This password will be required for all sensitive operations.
                    Please save this password securely.
                </p>
                
                <div className="generated-password">
                    <label>Your Transaction Password:</label>
                    <div className="password-display">
                        <code>{showPassword ? transactionPassword : '••••••'}</code>
                        <button type="button" onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? '🙈 Hide' : '👁️ Show'}
                        </button>
                    </div>
                    <p className="instruction">
                        Please take a screenshot or note down this password. You will need it for future transactions.
                    </p>
                </div>
                
                {error && <div className="error-message">{error}</div>}
                
                <form onSubmit={handleSubmit}>
                    <div className="confirm-section">
                        <label>Confirm Transaction Password:</label>
                        <input
                            type="password"
                            placeholder="Re-enter 6-digit password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    
                    <div className="modal-actions">
                        <button type="submit" disabled={loading}>
                            {loading ? 'Setting...' : 'Confirm & Continue'}
                        </button>
                    </div>
                </form>
                
                <p className="footer-note">
                    This password is stored securely. If forgotten, contact your admin to reset it.
                </p>
            </div>
        </div>
    );
};

export default FirstLoginSetup;